import { isFinanceChannel } from "@qoohoo/common/helpers/channel";
import { getOGImageType } from "@qoohoo/common/utils/url";

import useEntityStore from "store/entityStore";

export function checkShouldSEOIndex ()  {
    let _shouldIndex;

    const entity = useEntityStore.getState().entity;

    const isCategoryFinance = isFinanceChannel(undefined, entity.data.title, entity.data.description);
    
    _shouldIndex = !(entity.data.isPrivate || isCategoryFinance);

    return _shouldIndex;
}

export function getEntitySEOConfig() {
    let seoConfig;

    const entity = useEntityStore.getState().entity;

    if(!entity?.data) {
        seoConfig = null;
    } else {
        const title = `${entity.data.name} • qoohoo`;
        const imageFromMedia = entity.data.media?.find(img=>img.file_type==="image");
        const imageUrl = entity.data.image?.url || imageFromMedia?.url;

        seoConfig = {
            url: entity.data.share_url,
            title: title,
            description: entity.data.description,
            metaDescription: "",
            image: {},
        }

        if(imageUrl) {
            seoConfig.image = {
                url: imageUrl,
                type: getOGImageType(imageUrl),
            };
        }
    }

    return seoConfig;
}